import React from 'react'
import Button from '../../../atoms/Button/Button'
import Modal from '../../../molecules/Modal/Modal'

interface SaveChangesModalProps {
  isOpen?: boolean
  onSave: () => void
  onDiscard: () => void
}

const SaveChangesModal = ({ isOpen = false, onSave, onDiscard }: SaveChangesModalProps) => {
  return (
    <Modal showClose={false} isOpen={isOpen}>
      <h3 className="Modal_Title">Review changes</h3>
      <div className="Modal_Content">
        <p>Before you go, would you like to save or discard the changes you made?</p>
      </div>
      <div className="Modal_Actions">
        <Button link onClick={onSave}>
          Save
        </Button>
        <Button link onClick={onDiscard}>
          Discard
        </Button>
      </div>
    </Modal>
  )
}

export default SaveChangesModal
